import React from "react";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import StyledCheckbox from "../../../../../utils/componentutils/StyledCheckbox";
import Grid from "@material-ui/core/Grid";

export default function LongShortCheckBoxes({top, dispatchTop, usedSymbols}) {
    let isAlreadyLong = top.goLong;
    let isAlreadyShort = top.goShort;
    let [symbolsUsed, setSymbolsUsed] = usedSymbols;

    return (
        <Grid container>
            <Grid item xs={6}>
                <FormControlLabel
                    control={
                        <StyledCheckbox
                            checked={isAlreadyLong}
                            onChange={(ev) => {
                                dispatchTop({goLong: ev.target.checked});
                            }}
                            name="goLong"
                        />
                    }
                    labelPlacement={"bottom"}
                    size={"small"}
                    label={<Typography style={{fontSize: 10}}>Long</Typography>}
                />
            </Grid>
            <Grid item xs={6}>
                <FormControlLabel
                    control={
                        <StyledCheckbox
                            checked={isAlreadyShort}
                            onChange={(ev) => {
                                dispatchTop({goShort: ev.target.checked});
                            }}
                            name="goShort"
                        />
                    }
                    size={"small"}
                    labelPlacement={"bottom"}
                    label={<Typography style={{fontSize: 10}}>Short</Typography>}
                />
            </Grid>
        </Grid>
    );
}